import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import PageLoader from '../loader';

// pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.js`;

type Props = {
    url: string;
    scale?: number;
    width?: number | undefined;
    customCenter?: string;
    text?: string;
    setDisableButton?: (key: boolean) => void;
    dynamicClass?: string;
};

const PdfViewer: React.FC<Props> = ({
    url,
    setDisableButton,
    text,
    scale = 1.5,
    dynamicClass,
    // width = 500,
    customCenter = 'd-flex justify-content-center new-react-pdf',
}) => {
    const [numPages, setNumPages] = useState<any>(null);

    return (
        <Document
            loading={<PageLoader text={text ? text : 'Loading offer document...'} />}
            // renderMode="svg"
            file={url}
            onLoadSuccess={({ numPages }) => {
                setNumPages(numPages);
                setDisableButton?.(false);
            }}
            className={dynamicClass || ''}
        >
            {Array.from(Array(numPages), (e, i) => i + 1).map((item) => (
                <Page className={customCenter} key={item} pageNumber={item} renderMode="canvas" scale={scale} />
            ))}
        </Document>
    );
};

export default PdfViewer;
